import React, { useState } from 'react';
import { FormGroup } from 'react-bootstrap';

export function CheckBox({
  name,
  options,
  label,
  disable,
  requiredField,
  error,
  fromForm,
  duplicatingItem,
  index,
  i,
  id,
  eleIndex,
  elekey,
  onChange,
  editingInput,
  showDelete,
  deleteItem,
  elementId,
  fromCustomSection,
}) {
  const [isOver, setIsOver] = useState(false);

  const mouseOver = () => {
    setIsOver(true);
  };
  const mouseOut = () => {
    setIsOver(false);
  };
  return (
    <FormGroup className="flex-fill position-relative">
      <div onMouseEnter={mouseOver} onMouseLeave={mouseOut}>
        <label className={`asterisk-req ${fromForm && 'd-flex'}`}>
          {label}
          {requiredField && <span>*</span>}
        </label>
        {options?.map((opt, opIndex) => {
          return (
            <div className="checkbox-label" key={`_${opIndex}_${eleIndex}_${i}_${index}`}>
              <input
                type="checkbox"
                id={`${opt?.name}_${opIndex}_${eleIndex}_${i}_${index}`}
                key={`${label}_${id}`}
                name={name}
                disabled={disable}
                checked={opt?.value}
                onChange={(e) => onChange(e.target.checked, opt?.name, i, eleIndex, index)}
              />
              <label htmlFor={`${opt?.name}_${opIndex}_${eleIndex}_${i}_${index}`} className="chklabel">
                <span>{opt?.name}</span>
              </label>
              {fromForm && isOver && (
                <div className="potemp-action-btns">
                  <button
                    type="button"
                    className="btn btn-border ml-auto py-0 px-1"
                    key={`${opIndex}_${eleIndex}_${i}_${index}_edit`}
                    onClick={() => editingInput(index, i, eleIndex)}
                  >
                    <span className="icon-edit" />
                  </button>
                  {showDelete && isOver && (
                    <button
                      type="button"
                      className="btn btn-border py-0 px-1"
                      key={`${opIndex}_${eleIndex}_${i}_${index}_delete`}
                      onClick={() => deleteItem(index, i, elekey, eleIndex)}
                    >
                      <span className="icon-delete" />
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-border  py-0 px-1"
                    key={`${opIndex}_${eleIndex}_${i}_${index}_duplicate`}
                    onClick={() => (fromCustomSection ? duplicatingItem(index, i, elementId, fromCustomSection) : duplicatingItem(index, i, elekey))}
                  >
                    <span className="icon-copy" />
                  </button>
                </div>
              )}
            </div>
          );
        })}
        {error?.status && (
          <span key={`${opIndex}_${eleIndex}_${i}_${index}`} className="error-message">
            {error.errorMsg}
          </span>
        )}
      </div>
    </FormGroup>
  );
}
export default CheckBox;
